import { CreatePartyDialog } from "../../party/components/CreatePartyDialog";

export function PartiesPageIntro() {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Répertoire des clients et référents utilisés dans les documents, commissions, crédits et
        mouvements d'épargne.
      </p>
      <CreatePartyDialog />
    </div>
  );
}
